/* Small, scoped adapters; native cart, filter and app handlers remain in charge. */
(() => {
  let queued=false;
  const frames=new WeakSet(), sizes=new WeakMap();
  const observer='ResizeObserver' in window ? new ResizeObserver(()=>schedule()) : null;
  function crop(frame) {
    const wrapper=frame.closest('.hero__wrapper,.collection__image');
    if (!wrapper) return;
    const size=[wrapper.getBoundingClientRect().width.toFixed(2),innerWidth,innerHeight].join(':');
    if(sizes.get(wrapper)===size)return;
    // Measure the native banner before cropping; never measure a previously cropped height.
    wrapper.classList.remove('vnk-collection-crop');
    const height=frame.getBoundingClientRect().height;
    if (!height || !frame.querySelector('img')) return;
    const value=height.toFixed(2)+'px';
    if(wrapper.style.getPropertyValue('--vnk-banner-original-height')!==value)wrapper.style.setProperty('--vnk-banner-original-height',value);
    wrapper.classList.add('vnk-collection-crop');
    sizes.set(wrapper,size);
  }
  function init() {
    // The consent app can recreate its links after page load or a language change.
    const legal=document.querySelector('[data-vnk-legal-url]')?.dataset.vnkLegalUrl || '/policies/legal-notice';
    document.querySelectorAll('#pandectes-banner a.cc-link').forEach(link=>{
      if(link.textContent.trim().toLocaleLowerCase('de')==='impressum'&&link.getAttribute('href')!==legal)link.setAttribute('href',legal);
    });
    document.querySelectorAll('.vnk-polished-collection #MainContent .image__hero__frame').forEach(frame=>{
      crop(frame);
      if (!frames.has(frame)) { frames.add(frame); observer?.observe(frame.closest('.hero__wrapper,.collection__image')); }
    });
  }
  const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;init();});}};
  function start(){init();new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',schedule);
})();
